<template>
  <canvas-container></canvas-container>
</template>

<script>
import CanvasContainer from "../components/CanvasContainer.vue";

export default {
  components: {
    CanvasContainer,
  },
  metaInfo: {
    title: "사진",
  },
};
</script>

<style scoped></style>
